import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { CoreUiPartialState, getBranch, getCustomerOrderDetailsForTask, getUserId } from '@pos-app/core-ui';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-task-new',
  styleUrls: ['./task-new.component.scss'],
  templateUrl: './task-new.component.html',
})
export class NewTaskComponent implements OnInit {
  raisedBy$: Observable<string>;
  sourceSite$: Observable<string>;
  private unSubscribe$ = new Subject<void>();
  orderDetails: any;

  constructor(private coreUIStore: Store<CoreUiPartialState>, private router: Router) {}

  ngOnInit() {
    this.raisedBy$ = this.coreUIStore.pipe(select(getUserId));
    this.sourceSite$ = this.coreUIStore.pipe(
      takeUntil(this.unSubscribe$),
      select(getBranch),
      map((branch) => branch.BranchDescription)
    );
    this.coreUIStore.pipe(select(getCustomerOrderDetailsForTask)).subscribe((orderDetails) => {
      if (orderDetails) {
        this.orderDetails =  orderDetails?.customerOrderDetails;
      }
    });
  }
}
